import axios from 'axios'
const API_PATH = '/api/v2/admins/sellers/market_products/images'

const MarketplaceProductImageApiV2 = {

  /**
   * Replace current market_product.seller_image with new image
   * @param {Number} seller_image_id - Seller Market Product ID
   * @param {File} file - Seller Market Product ID
   */
  replace: async ({
    seller_image_id,
    file
  }) => {
    const payload        = new FormData()
    const image_file_key = 'market_product_image[file]'

    payload.append(image_file_key, file)

    const path = `${API_PATH}/${seller_image_id}/replace`

    const response = axios.patch(path, payload)
    return response
  }

}

export default MarketplaceProductImageApiV2
